// DropdownPill.jsx
import React, { useEffect, useRef, useState } from "react";

export default function DropdownPill({
  options = [],
  value,
  onChange = () => {},
  placeholder = "Select",
  className = "",
}) {
  const [open, setOpen] = useState(false);
  const btnRef = useRef(null);
  const menuRef = useRef(null);
  const selected = options.find((o) => o.value === value);

  useEffect(() => {
    const onClick = (e) => {
      if (
        !btnRef.current?.contains(e.target) &&
        !menuRef.current?.contains(e.target)
      )
        setOpen(false);
    };
    const onEsc = (e) => e.key === "Escape" && setOpen(false);
    document.addEventListener("mousedown", onClick);
    document.addEventListener("keydown", onEsc);
    return () => {
      document.removeEventListener("mousedown", onClick);
      document.removeEventListener("keydown", onEsc);
    };
  }, []);

  return (
    <div className={`relative inline-block ${className}`}>
      <button
        ref={btnRef}
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="min-w-[200px] w-full px-3 py-2 bg-white rounded-xl 
                   border border-gray-300 text-[#6B7280] text-sm 
                   flex items-center justify-between focus:outline-none transition"
      >
        <span
          className={`truncate ${
            selected?.label ? "text-[#374151]" : "text-[#717182]"
          }`}
        >
          {selected?.label ?? placeholder}
        </span>
        <svg
          className={`w-4 h-4 text-gray-400 transition-transform ${
            open ? "rotate-180" : ""
          }`}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 8l4 4 4-4"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {open && (
        <div
          ref={menuRef}
          className="absolute z-30 mt-2 w-full rounded-xl bg-white border border-gray-200 shadow-lg overflow-hidden"
        >
          <ul className=" overflow-y-auto">
            {options.map((opt) => (
              <li key={opt.value}>
                <button
                  type="button"
                  onClick={() => {
                    onChange(opt.value);
                    setOpen(false);
                  }}
                  className={`w-full text-left px-4 py-2 text-sm ${
                    value === opt.value
                      ? "bg-[#E17954] text-white font-medium"
                      : "hover:bg-[#E17954] hover:text-white text-[#374151]"
                  }`}
                >
                  {opt.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
